import { HeaderContainer, TitleSection } from "./UCPListHeader.styled";
import { Typography } from "@ann/web-components";
import ContactsActionBar from "./ContactsActionBar";

const UCPListHeader = (props) => (
  <HeaderContainer>
    <TitleSection>
      <Typography category="title" size="large" weight="bold">
        Contacts
      </Typography>
    </TitleSection>
    <ContactsActionBar {...props} />
  </HeaderContainer>
);

export default UCPListHeader; 